import { useContext } from 'react'
import { PresentationContext } from './PresentationContext'

export function usePresentation() {
  return useContext(PresentationContext)
}
